// Central API client and Auth context for Noble Strategies Consulting
// Manages JWT token (localStorage) + attaches Bearer header + cookie-based session

import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Global axios instance
export const api = axios.create({
  baseURL: API,
  withCredentials: true, // send cookies for cross-origin backend
});

const TOKEN_KEY = "nsc.access_token";

export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);
export const setStoredToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

// Attach bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-clear on 401 (except for /auth/me + login/register)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (
      err.response?.status === 401 &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/register")
    ) {
      // Only clear silently; the AuthProvider handles UX
    }
    return Promise.reject(err);
  }
);
